export function poundsToPence(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(String(value).replace(/[,£$€\s]/g, ''));
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
}

export function penceToPoundsInput(pence: unknown): string {
  const n = typeof pence === 'number' ? pence : Number(pence);
  if (!Number.isFinite(n)) return '';
  return (n / 100).toFixed(2);
}

export function supplierOrderVatPence(netPence: number, supplierVat: 'none' | 'standard' | undefined): number {
  if (supplierVat !== 'standard') return 0;
  if (!Number.isInteger(netPence) || netPence < 0) return 0;
  return Math.round((netPence * 20) / 100);
}

export function vatPercentForCurrency(currency: string): '0' | '20' {
  return currency.trim().toUpperCase() === 'EUR' ? '0' : '20';
}

export function vatPenceFromPercent(netPence: number, percent: string): number | null {
  const text = percent.trim();
  if (text === '') return null;
  const rate = Number(text);
  if (!Number.isFinite(rate)) return null;
  return Math.round((netPence * rate) / 100);
}

export function vatPenceOnLines(lineNets: number[], percent: string): number | null {
  const text = percent.trim();
  if (text === '') return null;
  let sum = 0;
  for (const net of lineNets) {
    const part = vatPenceFromPercent(net, text);
    if (part == null) return null;
    sum += part;
  }
  return sum;
}

export function vatRateValue(netPence: number, vatPence: number | null | undefined): string {
  if (typeof vatPence !== 'number') return '';
  const percent = percentInputFromVat(netPence, vatPence);
  return percent === '0' || percent === '20' ? percent : '';
}

export function percentInputFromVat(netPence: number, vatPence: number): string {
  if (vatPence === 0) return '0';
  if (netPence <= 0) return '';
  const rounded = Math.round(((vatPence * 100) / netPence) * 100) / 100;
  if (Math.abs(Math.round((netPence * rounded) / 100) - vatPence) > 1) return '';
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
}

export function sterlingBooksLine(currency: unknown, gbpPence: unknown, fxRate: unknown, fxRateOn: unknown): string {
  const code = String(currency || 'GBP').trim().toUpperCase();
  if (code === 'GBP' || code === 'POUND_STERLING' || gbpPence == null || gbpPence === '' || Number(gbpPence) === 0) return '';
  const money = formatMoney(gbpPence, 'GBP');
  if (!money) return '';
  const rate = String(fxRate || '').trim();
  const on = String(fxRateOn || '').trim();
  return rate ? `Books ${money} at ${rate} ${code} per £1${on ? ` (${on})` : ''}` : `Books ${money}`;
}

export function formatMoney(pence: unknown, currency = 'GBP'): string {
  const n = typeof pence === 'number' ? pence : Number(pence);
  if (!Number.isFinite(n)) return '';
  try {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(n / 100);
  } catch {
    return `${(n / 100).toFixed(2)} ${currency}`;
  }
}
